import { ISpotlightData, ISpotlightItem } from  "@/interfaces/spotlight";
import { getImageAsset } from "./Images";

export function transformToSpotlightData(data: any): ISpotlightData {
    const spotlightTitle = data.title;

    const items: ISpotlightItem[] = data.items
        .map((page: any) => {
            if (!page?.id) {
                return null;
            }
            //the text is store and then checked for any encoded text
            const textItem = page.items?.find((i: any) => i.type === 'text');
            const rawBody = textItem?.text || '';
            
            //just removes the p tags and new line tags
            const body = decodeHtmlEncoding(rawBody);

            //the links come through as html with an <a> tag, aria lable and button text
            const htmlItem = page.items?.find((i: any) => i.type === 'html');
            const link = htmlItem
                ? parseHtmlForLinkValues(htmlItem.html)
                : { uri: '', text: '', label: '' };

            //the images come through as image items
            //if there is no image, we arent going to include this item
            const imageItem = page.items?.find((i: any) => i.type === 'image');
            if (!imageItem?.image?.url) {
                return null;
            }

            const imageUri = getImageAsset(600, imageItem.image.url) || '';

            return {
                id: page.id,
                image: { uri: imageUri },
                title: page.title,
                body,
                link,
            };
        })
        .filter(Boolean) // remove any invalid or bad data items
        .slice(0, 5);    // show up to 5 items from the full array

    return { spotlightTitle, items };
}

export function parseHtmlForLinkValues(html: string): { uri: string; text: string; label: string } {
    //getting all links which are complete from the html
    const anchorMatch = html.match(/<a\s+[^>]*>[\s\S]*?<\/a>/i);
    if (!anchorMatch) {
        return { uri: '', text: '', label: '' };
    }

    //only using the first one
    const anchorHtml = anchorMatch[0];

    const labelMatch = anchorHtml.match(/aria-label=['"]([^'"]+)['"]/i);
    const textMatch = anchorHtml.match(/>([^<]+)<\/a>/i);
    const hrefMatch = anchorHtml.match(/href=['"]([^'"]+)['"]/i);

    //if there is a url then we apply the second item in the array (the first item is just "href=")
    const rawUri = hrefMatch ? hrefMatch[1] : '';
    const orgShortcode = window.location.host.split('.')[0];

    // Normalize to full URL if it doesn’t start with http
    const normalizedUri = rawUri && !rawUri.startsWith('http')
        ? `https://${rawUri}`
        : rawUri;

    let uri = normalizedUri;

    if (uri) {
        try {
            const urlNoParam = new URL(uri);
            urlNoParam.searchParams.append('utmCustomer', `${orgShortcode}_ThriveCMS`);
            uri = urlNoParam.toString();
        } catch (err) {
            console.error('Invalid URL:', uri, err);
        }
    }

    return {
        uri,
        text: textMatch ? textMatch[1].trim() : '',
        label: labelMatch ? labelMatch[1].trim() : ''
    };
}

function decodeHtmlEncoding(string: string): string {
    // Decode HTML entities
    const txt = document.createElement('textarea');
    txt.innerHTML = string;
    let decoded = txt.value;

    // Replace <br> and <br /> with newline
    decoded = decoded.replace(/<br\s*\/?>/gi, '\n');

    // Remove <p> and </p> tags
    decoded = decoded.replace(/<\/?p>/gi, '');

    // Trim whitespace
    decoded = decoded.trim();

    return decoded;
}